// extracted by mini-css-extract-plugin
export default {"section":"VideoSection_section__LMYNR","title":"VideoSection_title__0-eJN","playerWrap":"VideoSection_playerWrap__APdYW","playerInner":"VideoSection_playerInner__+UNwp"};